import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { validateEmail } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { InputField } from "../../../../Components/formElements/InputField";
import toast from "react-hot-toast";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import config from "../../../../services/configuration";
  

const SendEmailModalV5 = React.forwardRef((props, ref) => {
  const { data } = props;
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    documentNumber: "",
    companyCodeDesc: "",
    purchasingDocumentTaxTotalValue: "",
    purchasingDocumentItemTotalValue: "",
    statusHeader: "",
    purchasingDocumentType: "",
    vendorCode: "",
    vendorName: "",
    purchasingDocumentDate: "",
    paymentTerms: "",
    email: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const failureModalData = { title: "Warning", ErrorMsg: "" };
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [disable, setDisabled] = useState(false);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line 
  const [getFileViewData, setFileViewData] = useState(null);

  // Load form data when modal opens
  useEffect(() => {
    if (props.show && data?.purchasingDocumentNr) {
      setFormData({
        documentNumber: data?.purchasingDocumentNr || "",
        companyCodeDesc: data?.companyCodeDesc || "",
        purchasingDocumentTaxTotalValue: data?.purchasingDocumentTaxTotalValue || "",
        purchasingDocumentItemTotalValue: data?.purchasingDocumentItemTotalValue || "",
        statusHeader: data?.statusHeader || "",
        purchasingDocumentType: data?.purchasingDocumentType || "",
        vendorCode: data?.vendorCode || "",
        vendorName: data?.vendorName || "",
        purchasingDocumentDate: data?.purchasingDocumentDate || "",
        paymentTerms: data?.paymentTerms || "",
        email: "",
      });
      setSelectedFile(null);
    }
  }, [props.show, data]);

  // Reset on close
  useEffect(() => {
    if (!props.show) {
      setFormData({ documentNumber: "", email: "" });
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [props.show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  // ✅ Remove selected file
  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // ✅ Direct multipart/form-data API call
const callAPI = async (formData) => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const token = userData?.token || "";
  const api_url = config.BASE_URL + "api/sendPOEmailToSupplier";

  try {
    const response = await fetch(api_url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, 
      },
      body: formData, 
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "API Error");
    }

    return data;
  } catch (error) {
    console.error("Fetch API Error:", error);
    throw error;
  }
};

const handleSubmit = async () => {
  const requiredFields = [];

  if (!formData.email) {
    requiredFields.push("* Email is required.");
  } else if (!validateEmail(formData.email)) {
    requiredFields.push("* Invalid email address.");
  }

  if (requiredFields.length > 0) {
    setErrorFields(requiredFields);
    setShowFailureModal(true);
    return;
  }

  setDisabled(true);

  try {
    const payload = new FormData();

    payload.append("documentNumber", formData.documentNumber || "");
    payload.append("companyName", formData.companyCodeDesc || "");
    payload.append("companyCodeDesc", formData.companyCodeDesc || "");
    payload.append("purchasingDocumentTaxTotalValue", formData.purchasingDocumentTaxTotalValue || "");
    payload.append("purchasingDocumentItemTotalValue", formData.purchasingDocumentItemTotalValue || "");
    payload.append("statusHeader", formData.statusHeader || "");
    payload.append("purchasingDocumentType", formData.purchasingDocumentType || "");
    payload.append("vendorCode", formData.vendorCode || "");
    payload.append("vendorName", formData.vendorName || "");
    payload.append("purchasingDocumentDate", formData.purchasingDocumentDate || "");
    payload.append("paymentTerms", formData.paymentTerms || "");
    payload.append("email", formData.email || "");
    payload.append("registrationLink", "");
    payload.append("timeZone", Intl.DateTimeFormat().resolvedOptions().timeZone);

    // ✅ FILE (important)
    if (selectedFile) {
      payload.append("files", selectedFile);
    }

    // 🔍 DEBUG (very important)
    console.log("===== FORM DATA =====");
    for (let pair of payload.entries()) {
      console.log(pair[0], pair[1]);
    }

    const result = await callAPI(payload);

    if (result?.status === 200) {
      toast.success(result?.message || "Mail sent successfully", {
        duration: 2000,
        position: "top-right",
      });
      props?.onHide();
    } else {
      toast.error(result?.message || "Failed to send email");
    }

  } catch (error) {
    console.error("Submit Error:", error);
    toast.error(error.message || "Something went wrong");
  } finally {
    setDisabled(false);
  }
};

  const hideFailureModal = () => setShowFailureModal(false);
  const handleViewFileHide = () => setShowFileViewModal(false);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Send Email</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Purchase Order Number */}
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Purchase Order Number"
              name="purchasingDocumentNr"
              id="purchasingDocumentNr"
              placeholder=""
              value={data?.purchasingDocumentNr || ""}
              disabled={true}
            />
          </Col>
        </Row>

        {/* Email */}
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Email"
              name="email"
              id="email"
              placeholder="test@gmail.com"
              value={formData.email || ""}
              onChange={handleChange}
            />
          </Col>
        </Row>

        {/* ✅ File Attachment Input */}
        <Row className="mb-3">
          <Col>
            <label style={{ fontWeight: 500, fontSize: "14px", display: "block", marginBottom: "6px" }}>
              Attach File <span style={{ color: "#999", fontWeight: 400 }}>(optional)</span>
            </label>

            {/* Hidden native file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/png,image/jpeg,application/pdf"
              style={{ display: "none" }}
            />

            {/* Custom Upload Button */}
            {!selectedFile && (
              <button
                type="button"
                onClick={() => fileInputRef.current.click()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "8px 16px",
                  border: "2px dashed #ced4da",
                  borderRadius: "6px",
                  background: "#f8f9fa",
                  color: "#495057",
                  cursor: "pointer",
                  fontSize: "13px",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <img
                  src="assets/img/newIcons/attached-file.png"
                  alt="attach"
                  style={{ width: "20px", height: "20px" }}
                  onError={(e) => { e.target.style.display = "none"; }}
                />
                Click to attach a file
              </button>
            )}

            {/* Selected File Preview */}
            {selectedFile && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px 12px",
                  background: "#e8f5e9",
                  borderRadius: "6px",
                  border: "1px solid #a5d6a7",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <img
                    src="assets/img/newIcons/attached-file.png"
                    alt="file"
                    style={{ width: "20px", height: "20px" }}
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                  <div>
                    <div style={{ fontSize: "13px", color: "#2e7d32", fontWeight: 500 }}>
                      {selectedFile.name}
                    </div>
                    <div style={{ fontSize: "11px", color: "#666" }}>
                      {(selectedFile.size / 1024).toFixed(1)} KB
                    </div>
                  </div>
                </div>

                {/* Remove file + Change file buttons */}
                <div style={{ display: "flex", gap: "6px" }}>
                  <button
                    type="button"
                    onClick={() => fileInputRef.current.click()}
                    style={{
                      padding: "4px 10px",
                      fontSize: "11px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      background: "#fff",
                      cursor: "pointer",
                      color: "#495057",
                    }}
                  >
                    Change
                  </button>
                  <button
                    type="button"
                    onClick={handleRemoveFile}
                    style={{
                      padding: "4px 10px",
                      fontSize: "11px",
                      border: "none",
                      borderRadius: "4px",
                      background: "#dc3545",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <button
          onClick={handleSubmit}
          disabled={disable}
          className="btn btn-primary"
        >
          {disable ? "Sending..." : "Submit"}
        </button>
        <button onClick={props?.onHide} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        showDelete={false}
      />
    </Modal>
  );
});

export default SendEmailModalV5;